import { getSingleAgeRangeValue } from 'components/date/AgeRange'
import { FaixaEtariaEnum } from 'graphql/types.generated'
import { createValidator, empty, ErrorObject, range, required } from 'util/validation'

import {
  AcompanhamentoCondicaoSaudeFormModel,
  IvcfFilterModel,
  TipoVulnerabilidadeEnum,
} from './model/model-acompanhamentoCondicaoSaude'

export const validate = createValidator<AcompanhamentoCondicaoSaudeFormModel>(
  {
    equipeResponsavel: required,
  },
  (values: AcompanhamentoCondicaoSaudeFormModel, errors: ErrorObject<AcompanhamentoCondicaoSaudeFormModel>) => {
    const { faixaEtariaRange, tipoFaixaEtaria, tipoVulnerabilidadeSelected, tria } = values

    if (tipoVulnerabilidadeSelected === TipoVulnerabilidadeEnum.TRIA) {
      errors.tria = {
        periodoRegistro: required(tria?.periodoRegistro),
        resultadosTria: required(tria?.resultadosTria),
      }
    }

    if (FaixaEtariaEnum.OUTRA === tipoFaixaEtaria && !errors.faixaEtariaRange) {
      errors.faixaEtariaRange = required(getSingleAgeRangeValue(faixaEtariaRange))
    }

    return errors
  }
)

export const validatorFiltrosAvancados = createValidator<IvcfFilterModel>(
  {},
  (values: IvcfFilterModel, errors: ErrorObject<IvcfFilterModel>) => {
    if (values.exibirApenasCidadaosIdososSemIvcf) {
      errors.pontuacao = empty(values.pontuacao)
      errors.riscoVulnerabilidade = empty(values.riscoVulnerabilidade)
      errors.subgrupo = empty(values.subgrupo)
    } else {
      errors.pontuacao = range(0, 40)(values.pontuacao?.firstValue) || range(0, 40)(values.pontuacao?.secondValue)
    }

    return errors
  }
)
